import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { CommercialCampaignItem } from "./CommercialCampaignItem";
import { InputDate } from "../../../theme/Input/InputDate";


export const CommercialCampaign = () => {

    const campaign = useDataBean(_CommercialCampaign);
    const addprod = useDataBean(_AddCommercialCampaign);
    const paginador = usePaginator();
    const [month, setMonth] = useState<any>(null);
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalprod, setModalprod] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcamp, setModalcamp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        campaign.instance.getCommercialCampaignCatalog(year, month, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const addCommercialCampaignItem = () => {
        //console.log(entailment.bean);
        addprod.instance.addCommercialCampaignItem(campaign.bean.IDCommercialCampaign, addprod.bean.IDProduct, addprod.bean.PriceValue, addprod.bean.Description).then(
            (resp: any) => {
                getLista();
                setModalprod({ ...modalprod, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        campaign.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        campaign.instance.deleteCommercialCampaign(campaign.bean.IDCommercialCampaign).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        campaign.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCommercialCampaign', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Desde', property: 'FromDate', visible: true },
        { title: 'Hasta', property: 'UptoDate', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Agregar Productos', icono: 'ri-file-add-fill', visible: single.canEdit(), evento: () => { setModalprod({ ...modalprod, "view": true }) } },
            { titulo: 'Productos de la Campaña', icono: 'ri-dashboard-fill', visible: single.canEdit(), evento: () => { setModalcamp({ ...modalcamp, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Campañas Comerciales">
            <div className="row">
                <div className="col-md-6">
                    <AccountantYear label='Vigencia' idSelector={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={campaign.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={campaign.bean.Name} onChange={campaign.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha Desde" name="FromDate" value={campaign.bean.FromDate} setDate={(e) => { campaign.setBean({ ...campaign.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha Hasta" name="UptoDate" value={campaign.bean.UptoDate} setDate={(e) => { campaign.setBean({ ...campaign.bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={campaign.bean.Description} onChange={campaign.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalprod} updateModal={setModalprod} eventModal={addCommercialCampaignItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto" value={addprod.bean.IDProduct} onChange={(e) => { addprod.setBean({ ...addprod.bean, "IDProduct": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Precio Promocional</label>
                                <input type="text" name="PriceValue" className="form-control" value={addprod.bean.PriceValue} onChange={(e) => { addprod.setBean({ ...addprod.bean, "PriceValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={addprod.bean.Description} onChange={addprod.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalcamp} updateModal={setModalcamp}>
                        <div className="row">
                            <CommercialCampaignItem idCommercialCampaign={campaign.bean.IDCommercialCampaign} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {campaign.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}